// extracted by mini-css-extract-plugin
export default {"container":"NoXGMZ","form-container":"Pb0sk_"};